import { useValidateTimesheetRowApi } from '@oc/pages/importers_rsi/validations/impl/timesheet/useValidateRowTimesheet';
import { useCallback, useRef } from 'react';
import { RsiData, RsiTableOnErrorCallback, RsiTableValidator } from '../../../Types';
import { useImportersIntl } from '../../../translations/useImportersIntl';
import { isInvalidField, sanitizeRsiArrayData, sanitizeRsiData } from '../validationUtils';

export function useValidateTableTimesheet(): RsiTableValidator {
  const { get } = useValidateTimesheetRowApi();
  const { invalidField } = useImportersIntl();

  const getRef = useRef(get);
  getRef.current = get;
  const invalidFieldRef = useRef(invalidField);
  invalidFieldRef.current = invalidField;

  return useCallback(async (table: RsiData[], addError: RsiTableOnErrorCallback) => {
    const response = await getRef.current({
      variables: {
        input: {
          values: table.map((data, index) => ({
            index,
            urnToValueMap: sanitizeRsiData(data, { allow: 'all' }),
            urnToValuesMap: sanitizeRsiArrayData(data, { allow: 'all' })
          }))
        }
      }
    });
    response.data?.result.validations?.forEach((item) => {
      if (isInvalidField(item)) {
        addError(item.index ?? 0, item.urn, {
          level: 'error',
          message: item.result.message ?? invalidFieldRef.current
        });
      }
    });
  }, []);
}
